"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buttonVariant = exports.buttonGroupSpacing = exports.buttonSize = exports.buttonNovoDark = exports.buttonNovo = exports.button = void 0;
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const timing_const_1 = __importDefault(require("../choices/timing.const"));
const font_const_1 = __importDefault(require("../choices/font.const"));
const size_const_1 = __importDefault(require("../choices/size.const"));
const { novo, novoDark } = oxygen_theme_1.default;
const button = {
    // Primary
    backgroundColorPrimary: color_const_1.default.dodgerBlue,
    backgroundColorPrimaryHover: color_const_1.default.dodgerBlue400,
    backgroundColorPrimaryActive: color_const_1.default.dodgerBlue700,
    backgroundColorPrimaryDisabled: color_const_1.default.dodgerBlue300,
    borderColorPrimary: color_const_1.default.dodgerBlue,
    borderColorPrimaryHover: color_const_1.default.dodgerBlue400,
    borderColorPrimaryActive: color_const_1.default.dodgerBlue700,
    borderColorPrimaryDisabled: color_const_1.default.dodgerBlue300,
    fontColorPrimary: color_const_1.default.white,
    fontColorPrimaryDisabled: color_const_1.default.dodgerBlue100,
    // Secondary
    backgroundColorSecondary: color_const_1.default.white,
    backgroundColorSecondaryHover: color_const_1.default.cloudyBlue100,
    backgroundColorSecondaryActive: color_const_1.default.cloudyBlue300,
    backgroundColorSecondaryDisabled: color_const_1.default.white,
    borderColorSecondary: color_const_1.default.cloudyBlue300,
    borderColorSecondaryHover: color_const_1.default.cloudyBlue300,
    borderColorSecondaryActive: color_const_1.default.cloudyBlue300,
    borderColorSecondaryDisabled: color_const_1.default.cloudyBlue300,
    fontColorSecondary: color_const_1.default.pickledBluewood800,
    fontColorSecondaryDisabled: color_const_1.default.cloudyBlue300,
    // Tertiary
    backgroundColorTertiary: 'transparent',
    backgroundColorTertiaryHover: color_const_1.default.cloudyBlue100,
    backgroundColorTertiaryActive: color_const_1.default.cloudyBlue300,
    backgroundColorTertiaryDisabled: 'transparent',
    borderColorTertiary: color_const_1.default.cloudyBlue300,
    borderColorTertiaryHover: color_const_1.default.cloudyBlue300,
    borderColorTertiaryActive: color_const_1.default.cloudyBlue300,
    borderColorTertiaryDisabled: color_const_1.default.cloudyBlue300,
    fontColorTertiary: color_const_1.default.pickledBluewood800,
    fontColorTertiaryActive: undefined,
    fontColorTertiaryHover: undefined,
    fontColorTertiaryDisabled: color_const_1.default.cloudyBlue300,
    // Tertiary Reversed
    backgroundColorTertiaryReversed: 'transparent',
    backgroundColorTertiaryReversedHover: color_const_1.default.cloudyBlue100,
    backgroundColorTertiaryReversedActive: color_const_1.default.cloudyBlue300,
    backgroundColorTertiaryReversedDisabled: 'transparent',
    borderColorTertiaryReversed: color_const_1.default.cloudyBlue300,
    borderColorTertiaryReversedHover: color_const_1.default.cloudyBlue300,
    borderColorTertiaryReversedActive: color_const_1.default.cloudyBlue300,
    borderColorTertiaryReversedDisabled: color_const_1.default.cloudyBlue300,
    fontColorTertiaryReversed: color_const_1.default.cloudyBlue300,
    fontColorTertiaryReversedActive: color_const_1.default.pickledBluewood800,
    fontColorTertiaryReversedHover: color_const_1.default.pickledBluewood800,
    fontColorTertiaryReversedDisabled: color_const_1.default.cloudyBlue300,
    // Destructive
    backgroundColorDestructive: color_const_1.default.coral,
    backgroundColorDestructiveHover: color_const_1.default.candyPink,
    backgroundColorDestructiveActive: color_const_1.default.coral700,
    backgroundColorDestructiveDisabled: color_const_1.default.coral200,
    borderColorDestructive: color_const_1.default.coral,
    borderColorDestructiveHover: color_const_1.default.candyPink,
    borderColorDestructiveActive: color_const_1.default.coral700,
    borderColorDestructiveDisabled: color_const_1.default.coral200,
    fontColorDestructive: color_const_1.default.white,
    fontColorDestructiveDisabled: color_const_1.default.cloudyBlue100,
    // Success
    backgroundColorSuccess: color_const_1.default.jadeGreen,
    backgroundColorSuccessHover: color_const_1.default.jadeGreen400,
    backgroundColorSuccessActive: color_const_1.default.jadeGreen700,
    backgroundColorSuccessDisabled: color_const_1.default.jadeGreen200,
    borderColorSuccess: color_const_1.default.jadeGreen,
    borderColorSuccessHover: color_const_1.default.jadeGreen400,
    borderColorSuccessActive: color_const_1.default.jadeGreen700,
    borderColorSuccessDisabled: color_const_1.default.jadeGreen200,
    fontColorSuccess: color_const_1.default.white,
    fontColorSuccessDisabled: color_const_1.default.steel700,
    // Typography
    fontSize: font_const_1.default.sizeSm,
    lineHeight: font_const_1.default.lineHeightSm,
    fontFamily: font_const_1.default.family,
    fontWeight: font_const_1.default.weightAttention,
    fontSizeMedium: novo.bodyBold01.fontSize,
    fontFamilyMedium: novo.bodyBold01.fontFamily,
    fontWeightMedium: novo.bodyBold01.fontWeight,
    lineHeightMedium: novo.bodyBold01.lineHeight,
    letterSpacingMedium: novo.bodyBold01.letterSpacing,
    fontSizeSmall: novo.labelBold01.fontSize,
    fontFamilySmall: novo.labelBold01.fontFamily,
    fontWeightSmall: novo.labelBold01.fontWeight,
    lineHeightSmall: novo.labelBold01.lineHeight,
    letterSpacingSmall: novo.labelBold01.letterSpacing,
    fontSizeLarge: novo.bodyBold02.fontSize,
    fontFamilyLarge: novo.bodyBold02.fontFamily,
    fontWeightLarge: novo.bodyBold02.fontWeight,
    lineHeightLarge: novo.bodyBold02.lineHeight,
    letterSpacingLarge: novo.bodyBold02.letterSpacing,
    // Structure
    paddingSmall: `calc(${size_const_1.default.small} - 1px) calc(${size_const_1.default.default2x} - 1px)`,
    paddingLarge: `calc(${size_const_1.default.default} - 1px) calc(${size_const_1.default.medium} - 1px)`,
    paddingMedium: 'unset',
    heightMedium: 'unset',
    paddingLargeV2: `calc(${size_const_1.default.borderRadiusLarge} - 1px) calc(${size_const_1.default.default2x} - 1px)`,
    heightLargeV2: size_const_1.default.tableHeaderSize,
    borderSize: '1px',
    borderRadius: size_const_1.default.borderRadiusDefault,
    heightSmall: size_const_1.default.formItemSizeSmall,
    heightLarge: size_const_1.default.formItemSizeLarge,
    /**
     * @deprecated instead of `marginLeftSmall`and `marginBottomSmall`, please use `buttonGroupSpacingSmall` property
     */
    marginLeftSmall: size_const_1.default.default,
    marginBottomSmall: size_const_1.default.default,
    /**
     * @deprecated instead of `marginLeftLarge` and `marginBottomLarge`, please use `buttonGroupSpacingLarge` property
     */
    marginLeftLarge: size_const_1.default.default2x,
    marginBottomLarge: size_const_1.default.default2x,
    buttonGroupSpacingSmall: size_const_1.default.default,
    buttonGroupSpacingLarge: size_const_1.default.default2x,
    // Animation
    transitionDuration: timing_const_1.default.fast,
    borderSizeTertiary: '1px',
    isClassic: true,
};
exports.button = button;
const buttonNovo = {
    isClassic: false,
    fontSize: undefined,
    lineHeight: undefined,
    fontFamily: undefined,
    fontWeight: undefined,
    // Primary
    backgroundColorPrimary: novo.action01,
    backgroundColorPrimaryHover: novo.hover01,
    backgroundColorPrimaryActive: novo.active01,
    backgroundColorPrimaryDisabled: novo.disabled01,
    borderColorPrimary: 'unset',
    borderColorPrimaryHover: 'unset',
    borderColorPrimaryActive: 'unset',
    borderColorPrimaryDisabled: 'unset',
    shadowColorPrimaryFocus: novo.focus01,
    fontColorPrimary: novo.textColor06,
    fontColorPrimaryDisabled: novo.disabled04,
    // Secondary
    backgroundColorSecondary: novo.action02,
    backgroundColorSecondaryHover: novo.hover02,
    backgroundColorSecondaryActive: novo.active02,
    backgroundColorSecondaryDisabled: novo.disabled01,
    borderColorSecondary: 'unset',
    borderColorSecondaryHover: 'unset',
    borderColorSecondaryActive: 'unset',
    borderColorSecondaryDisabled: 'unset',
    shadowColorSecondaryFocus: novo.focus01,
    fontColorSecondary: novo.textColor04,
    fontColorSecondaryDisabled: novo.disabled04,
    // Tertiary
    backgroundColorTertiary: 'transparent',
    backgroundColorTertiaryHover: novo.hover02,
    backgroundColorTertiaryActive: novo.active02,
    backgroundColorTertiaryDisabled: novo.disabled01,
    borderColorTertiary: novo.ui01,
    borderColorTertiaryHover: novo.hover02,
    borderColorTertiaryActive: novo.active02,
    borderColorTertiaryDisabled: novo.disabled01,
    shadowColorTertiaryFocus: novo.focus01,
    borderSizeTertiary: '1px',
    fontColorTertiary: novo.textColor01,
    fontColorTertiaryActive: novo.icon05,
    fontColorTertiaryHover: novo.icon05,
    fontColorTertiaryDisabled: novo.icon03,
    // Tertiary Reversed
    backgroundColorTertiaryReversed: 'transparent',
    backgroundColorTertiaryReversedHover: novo.hover09,
    backgroundColorTertiaryReversedActive: novo.active09,
    backgroundColorTertiaryReversedDisabled: novo.disabled01,
    borderColorTertiaryReversed: novo.ui08,
    borderColorTertiaryReversedHover: novo.hover09,
    borderColorTertiaryReversedActive: novo.active09,
    borderColorTertiaryReversedDisabled: novo.disabled01,
    fontColorTertiaryReversed: novo.textColor04,
    fontColorTertiaryReversedActive: novo.icon01,
    fontColorTertiaryReversedHover: novo.icon01,
    fontColorTertiaryReversedDisabled: novo.icon07,
    // Destructive
    backgroundColorDestructive: novo.action03,
    backgroundColorDestructiveHover: novo.hover03,
    backgroundColorDestructiveActive: novo.active03,
    backgroundColorDestructiveDisabled: novo.disabled01,
    borderColorDestructive: 'unset',
    borderColorDestructiveHover: 'unset',
    borderColorDestructiveActive: 'unset',
    borderColorDestructiveDisabled: 'unset',
    shadowColorDestructiveFocus: novo.focus01,
    fontColorDestructive: novo.textColor06,
    fontColorDestructiveDisabled: novo.disabled04,
    // Success
    backgroundColorSuccess: novo.success01,
    backgroundColorSuccessHover: novo.hover04,
    backgroundColorSuccessActive: novo.active04,
    backgroundColorSuccessDisabled: novo.disabled01,
    borderColorSuccess: 'unset',
    borderColorSuccessHover: 'unset',
    borderColorSuccessActive: 'unset',
    borderColorSuccessDisabled: 'unset',
    shadowColorSuccessFocus: novo.focus01,
    fontColorSuccess: novo.textColor06,
    fontColorSuccessDisabled: novo.disabled04,
    // New shadow
    shadowBackgroundColorFocus: novo.ui06,
    // Typography
    fontSizeMedium: novo.bodyBold01.fontSize,
    fontFamilyMedium: novo.bodyBold01.fontFamily,
    fontWeightMedium: novo.bodyBold01.fontWeight,
    lineHeightMedium: novo.bodyBold01.lineHeight,
    letterSpacingMedium: novo.bodyBold01.letterSpacing,
    fontSizeSmall: novo.labelBold01.fontSize,
    fontFamilySmall: novo.labelBold01.fontFamily,
    fontWeightSmall: novo.labelBold01.fontWeight,
    lineHeightSmall: novo.labelBold01.lineHeight,
    letterSpacingSmall: novo.labelBold01.letterSpacing,
    fontSizeLarge: novo.bodyBold02.fontSize,
    fontFamilyLarge: novo.bodyBold02.fontFamily,
    fontWeightLarge: novo.bodyBold02.fontWeight,
    lineHeightLarge: novo.bodyBold02.lineHeight,
    letterSpacingLarge: novo.bodyBold02.letterSpacing,
    // Structure
    paddingLarge: `calc(${size_const_1.default.default} - 1px) calc(${size_const_1.default.medium} - 1px)`,
    paddingSmall: `${novo.spacing03} ${novo.spacing04}`,
    paddingMedium: `${novo.spacing03} ${novo.spacing05}`,
    paddingLargeV2: `${novo.spacing04} ${novo.spacing05}`,
    borderSize: '0',
    borderRadius: '6px',
    heightSmall: '32px',
    heightMedium: '40px',
    heightLarge: size_const_1.default.formItemSizeLarge,
    heightLargeV2: '48px',
    /**
     * @deprecated instead of `marginLeftSmall`and `marginBottomSmall`, please use `buttonGroupSpacingSmall` property
     */
    marginLeftSmall: novo.spacing03,
    marginBottomSmall: novo.spacing03,
    /**
     * @deprecated instead of `marginLeftLarge` and `marginBottomLarge`, please use `buttonGroupSpacingLarge` property
     */
    marginLeftLarge: novo.spacing05,
    marginBottomLarge: novo.spacing05,
    buttonGroupSpacingSmall: novo.spacing03,
    buttonGroupSpacingLarge: novo.spacing05,
    // Animation
    transitionDuration: '150ms',
};
exports.buttonNovo = buttonNovo;
const buttonNovoDark = {
    ...buttonNovo,
    // Primary
    backgroundColorPrimary: novoDark.action01,
    backgroundColorPrimaryHover: novoDark.hover01,
    backgroundColorPrimaryActive: novoDark.active01,
    backgroundColorPrimaryDisabled: novoDark.disabled01,
    fontColorPrimary: novoDark.textColor06,
    fontColorPrimaryDisabled: novoDark.disabled04,
    // Secondary
    backgroundColorSecondary: novoDark.action02,
    backgroundColorSecondaryHover: novoDark.hover02,
    backgroundColorSecondaryActive: novoDark.active02,
    backgroundColorSecondaryDisabled: novoDark.disabled01,
    fontColorSecondary: novoDark.textColor04,
    fontColorSecondaryDisabled: novoDark.disabled04,
    // Tertiary
    backgroundColorTertiary: 'transparent',
    backgroundColorTertiaryHover: novoDark.hover02,
    backgroundColorTertiaryActive: novoDark.active02,
    backgroundColorTertiaryDisabled: novoDark.disabled01,
    borderColorTertiary: novoDark.ui01,
    borderColorTertiaryHover: novoDark.hover02,
    borderColorTertiaryActive: novoDark.active02,
    borderColorTertiaryDisabled: novoDark.disabled01,
    fontColorTertiary: novoDark.textColor01,
    fontColorTertiaryActive: novoDark.icon05,
    fontColorTertiaryHover: novoDark.icon05,
    fontColorTertiaryDisabled: novoDark.icon03,
    // Tertiary Reversed
    backgroundColorTertiaryReversed: 'transparent',
    backgroundColorTertiaryReversedHover: novoDark.hover09,
    backgroundColorTertiaryReversedActive: novoDark.active09,
    backgroundColorTertiaryReversedDisabled: novoDark.disabled01,
    borderColorTertiaryReversed: novoDark.ui08,
    borderColorTertiaryReversedHover: novoDark.hover09,
    borderColorTertiaryReversedActive: novoDark.active09,
    borderColorTertiaryReversedDisabled: novoDark.disabled01,
    fontColorTertiaryReversed: novoDark.textColor04,
    fontColorTertiaryReversedActive: novoDark.icon01,
    fontColorTertiaryReversedHover: novoDark.icon01,
    fontColorTertiaryReversedDisabled: novoDark.icon07,
    // Destructive
    backgroundColorDestructive: novoDark.action03,
    backgroundColorDestructiveHover: novoDark.hover03,
    backgroundColorDestructiveActive: novoDark.active03,
    backgroundColorDestructiveDisabled: novoDark.disabled01,
    fontColorDestructive: novoDark.textColor06,
    fontColorDestructiveDisabled: novoDark.disabled04,
    // Success
    backgroundColorSuccess: novoDark.success01,
    backgroundColorSuccessHover: novoDark.hover04,
    backgroundColorSuccessActive: novoDark.active04,
    backgroundColorSuccessDisabled: novoDark.disabled01,
    fontColorSuccess: novoDark.textColor06,
    fontColorSuccessDisabled: novoDark.disabled04,
    // Shadow
    shadowBackgroundColorFocus: novoDark.ui06,
};
exports.buttonNovoDark = buttonNovoDark;
// the "types" here are deprecated, use the exports from the button package instead
const buttonSize = {
    small: 'small',
    big: 'big',
    large: 'large',
    medium: 'medium',
};
exports.buttonSize = buttonSize;
const buttonGroupSpacing = {
    small: 'small',
    large: 'large',
};
exports.buttonGroupSpacing = buttonGroupSpacing;
const buttonVariant = {
    primary: 'primary',
    secondary: 'secondary',
    success: 'success',
    destructive: 'destructive',
    tertiary: 'tertiary',
    tertiaryReversed: 'tertiaryReversed',
};
exports.buttonVariant = buttonVariant;
